/**
 * This file is part of the "box.co.il" project.
 *
 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */

;(function($) {
  /**
   * Get Storage value by key.
   *
   * @param {String} key
   * @param {*}      [defaultValue]
   *
   * @return {*}
   */
  Storage.getData = function(key, defaultValue) {
    defaultValue = defaultValue || undefined;

    if(typeof undefined == typeof this['data'] || !(key in this['data'])) {
      return defaultValue;
    }

    return this['data'][key];
  };

  /**
   * Check value by key in storage.
   * 
   * @param {String} key
   * @return {boolean}
   */
  Storage.hasData = function(key) {
    return !(typeof undefined == typeof this['data'] || !(key in this['data']));
  };
})(jQuery);